import { keyMapsGetter, keyMapsAction } from "./storeKeys";
import store from "../store";
import utility from "./utility";

const paytmError = (error) => {
  return { err: error };
};

const getCurrentLocation = () => {
  JSBridge.call('paytmGetLocation', {}, result => {
    if (result?.data) {
      const res = result.data;
      if (res.lat !== 0) {
        const payload = {
          coords: {
            latitude: res.lat,
            longitude: res.long
          }
        };
        return payload;
      } else {
        return paytmError('Location permission not given');
      }
    }
  });
};

const requestPermission = (requestObject) => {
  JSBridge.call('paytmRequestPermission', requestObject, result => {
    if (result?.data) {
      const res = result.data;
      if (res.location === 1) {
        return getCurrentLocation();
      }
      else {
        return paytmError('Location permission not given');
      }
    }
  });
};

const getLocation = () => {
  const requestObject = {
    permission: 'location'
  };
  JSBridge.call('paytmCheckPermission', requestObject, result => {
    if (result?.data) {
      const res = result.data;
      if (res.location === 1) {
        return getCurrentLocation();
      }
      else {
        return requestPermission(requestObject);
      }
    }
  });
};

const getUserDetails = (location) => {
  const ready = callback => {
    if (window.JSBridge) {
      if (callback) callback();
    } else {
      document.addEventListener('JSBridgeReady', callback, false);
      console.error('PAYTM Unable to get user details');
      utility.redirectToLoginScreen();
    }
  };

  const clientId = store.getters[keyMapsGetter.GET_PWA_CONFIG]?.vendorConfig?.PAYTM?.clientId || '';

  ready(() => {
    JSBridge.call(
      'paytmFetchAuthCode',
      {
        clientId: clientId
      },
      result => {
        result.partnerName = utility.getMiniAppStorageVal() || '';
        store.dispatch(keyMapsAction.SIGNIN_MINIAPP, result, {root: true});
      }
    )
  });
}

export default {
  getLocation,
  getUserDetails
};
